import React, {Component} from 'react';
import './Contacts.css';
import {withTranslation} from "react-i18next";

class Contacts extends Component {
    render() {
        const {t} = this.props;
        return (
            <div className='contacts-container'>
                <div className='contacts-wrapper'>
                    <div className='contacts-info'>
                        <div>
                            <h5>{t('contacts.title1')}</h5>
                            <p>{t('contacts.part1-1')}</p>
                            <p>{t('contacts.part1-2')}</p>
                            <p><a
                                href="https://yandex.ru/maps/213/moscow/?ll=37.630571%2C55.823029&mode=search&ol=geo&ouri=ymapsbm1%3A%2F%2Fgeo%3Fll%3D37.630579%2C55.823031%26spn%3D0.001%252C0.001%26text%3D%25D0%25A0%25D0%25BE%25D1%2581%25D1%2581%25D0%25B8%25D1%258F%252C%2B%25D0%259C%25D0%25BE%25D1%2581%25D0%25BA%25D0%25B2%25D0%25B0%252C%2B1-%25D1%258F%2B%25D0%259E%25D1%2581%25D1%2582%25D0%25B0%25D0%25BD%25D0%25BA%25D0%25B8%25D0%25BD%25D1%2581%25D0%25BA%25D0%25B0%25D1%258F%2B%25D1%2583%25D0%25BB%25D0%25B8%25D1%2586%25D0%25B0%252C%2B26%2B&z=17"
                                target="_blank">{t('contacts.part1-3')}</a></p>
                            <p>{t('contacts.part1-4')}</p>
                            <p className="phone">{t('contacts.part1-5')}</p>
                            <p><a href={'mailto:' + t('contacts.part1-6')}>{t('contacts.part1-6')}</a></p>
                        </div>

                        <div>
                            <h5>{t('contacts.title2')}</h5>
                            <p>{t('contacts.part2-1')}</p>
                            <p>{t('contacts.part2-2')}</p>
                            <p><a href={'mailto:' + t('contacts.part2-3')}>{t('contacts.part2-3')}</a></p>
                            <p>{t('contacts.part2-4')}</p>
                        </div>
                    </div>
                </div>
                <div className='contacts-photo container'></div>
            </div>);
    }
}

export default withTranslation()(Contacts);


// WEBPACK FOOTER //
// ./src/components/Contacts.js